import postAPI from './postAPI.js'

export default async function postDeleteAction(actionId) {
    const data = await postAPI('admin/taskflows/actions/delete', { id: actionId });
    return data;
}
